import { Periodicidade, isPeriodicidadeAnual } from '../../../../../shared/periodicidade';

export const YEARS_PAGE_SIZE = 12;
export const YEARS_RANGE_SIZE = 4;

/**
 * Quantos anos antes do ano atual o painel Anual exibe.
 * O restante (YEARS_PAGE_SIZE - 1 - YEARS_PAST_OFFSET) fica para o futuro.
 * Ajustado para o contexto comercial CEPPEM (planejamento, metas, recorrência).
 */
export const YEARS_PAST_OFFSET = 3;

/**
 * Devolve o ano inicial do bloco de 12 anos exibido no painel Anual.
 *
 * Aplica viés futuro (start = year - YEARS_PAST_OFFSET) porque o uso primário
 * em CEPPEM é planejamento comercial: o usuário quer mais espaço para frente
 * que para trás. Para histórico além de YEARS_PAST_OFFSET anos, usar prev/next
 * do painel.
 */
export function defaultYearsPageStart(year: number = new Date().getFullYear()): number {
  return year - YEARS_PAST_OFFSET;
}

/**
 * Calcula o array de anos exibido no painel + o pageStart efetivo.
 *
 * Retorna pageStart junto porque o componente persiste esse valor para a
 * próxima navegação de página (prev/next bloco de 12 anos no painel Anual).
 * Para periodicidade não-Anual, pageStart retornado é currentYear - 1
 * (ponto de referência do range fixo de 4 anos).
 */
export function computeYearsRange(
  periodicidade: Periodicidade,
  pageStart?: number
): { years: number[]; pageStart: number } {
  if (isPeriodicidadeAnual(periodicidade.id)) {
    const annualStart = pageStart ?? defaultYearsPageStart();
    return {
      years: Array.from({ length: YEARS_PAGE_SIZE }, (_, i) => annualStart + i),
      pageStart: annualStart
    };
  }
  const rangeStart = new Date().getFullYear() - 1;
  return {
    years: Array.from({ length: YEARS_RANGE_SIZE }, (_, i) => rangeStart + i),
    pageStart: rangeStart
  };
}
